import React, { useCallback, useEffect, useState } from "react";
import { translate } from "../Services/translation";
import QuantityStepperCart from "./QuantitystepperCart";
import FreeShippingBar from "../Muurikka/FreeShippingBar";
import FreeGift from "../Muurikka/FreeGift.container";
import { isMuurikka } from "./MiscellaneousMenu";
import Upsell from "../Muurikka/Components/Upsell";
import { useDispatch, useSelector } from "react-redux";
import { show } from '../Actions/Cart.action';

/**
 * Breakpoint here is NOT window viewport size, but the container size where the scroll container is, how much space the scoll container has.
 * For the mini cart, that would be the width of the mini-cart itself, the slideout element.
 */
const upsellConfig = [
    {
        breakpoint: 0,
        settings: {
            itemsToShow: 1.75
        }
    },
    {
        breakpoint: 525,
        settings: {
            itemsToShow: 2.5
        }
    },
    {
        breakpoint: 800,
        settings: {
            itemsToShow: 3.5
        }
    }
];


const MiniCart = (props) => {
    const dispatch = useDispatch();
    const [cartQty, setCartQty] = useState(
        props.quantity !== null ? props.quantity : 0
    );

    const { toggle: toggleMiniCart } = props;

    /**
     *
     * @param {KeyboardEvent} e
     * @returns {false|*}
     */
    const escFunction = (e) => e.key === 'Escape' && dispatch(show(false));

    useEffect(() => {
        document.addEventListener("keydown", escFunction);
        return () => document.removeEventListener("keydown", escFunction);
    }, []);

    useEffect(() => {
        setCartQty(props.quantity !== null ? props.quantity : 0);
    }, [props.quantity]);

    const onQuantityChange = (value, i) => {
        let rowSystemId = props.orderRows[i].rowSystemId;
        let currentQuantity = props.orderRows[i].quantity;
        let inStockQuantity = props.orderRows[i].inStockQuantity;
        if (parseInt(currentQuantity) <= parseInt(inStockQuantity)) {
            props.update(rowSystemId, value);
            setCartQty(cartQty + value - currentQuantity);
        }
    };

    const onRemoveProduct = (i) => {
        let rowSystemId = props.orderRows[i].rowSystemId;
        props.update(rowSystemId, 0);
        setCartQty(cartQty - props.orderRows[i].quantity);
    };

    if (!cartQty > 0) {
        return null;
    }

    return (
        <>
            {props.icon && cartQty > 0 &&
                <div className="cart-icon-container">
                    <a
                        className="cart__link--block"
                        onClick={toggleMiniCart}
                    >
                        <i className="cart__icon">
                            <svg className="icon">
                                <use href="/UI/images/sprites/habo-sprite.svg#cart"></use>
                            </svg>
                            <span className={`cart__quantity`}>{cartQty}</span>
                        </i>
                    </a>
                </div>
            }

            {!props.icon &&
                <div className="cart cart--mini">
                    <div
                        className={`cart__info ${
                            !props.showInfo ? "cart__info--hidden" : ""
                        }`}
                    >
                        <div className="cart__outerdiv">
                            <a
                                className="cart__closenullarea"
                                onClick={toggleMiniCart}
                            >
                                {" "}
                            </a>
                        </div>
                        <div className="cart__contentdiv mini-cart-content">
                            <header className="sidecart-header">
                                <div className="product-detail__buy-heading">
                                    <h6 className="buy-text fw-500">
                                        {translate("minicart.cartPanel")}
                                    </h6>
                                </div>
                                <svg
                                    onClick={toggleMiniCart}
                                    className="sidecart-header-close"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <line x1="18" y1="6" x2="6" y2="18"></line>
                                    <line x1="6" y1="6" x2="18" y2="18"></line>
                                </svg>
                            </header>
                            <main>
                                {props.orderRows.length === 0 &&
                                    <span>{translate('muha.cart.empty')}</span>
                                }

                                <ul className="cartitem-list cartitem-list--slim">
                                    {props.orderRows.length > 0 &&
                                        props.orderRows.map((orderRow, i) =>
                                            <li key={"li" + i}>
                                                <div className="cartitem">
                                                    <a href={orderRow.url} className="cartitem__thumb">
                                                        <img
                                                            key={"img" + i}
                                                            src={orderRow.image}
                                                            alt={orderRow.name}
                                                        />
                                                    </a>
                                                    <div className="cartitem__content">
                                                        <div className="cartitem__section">
                                                            <div className="cartitem__text">
                                                                <a
                                                                    href={orderRow.url}
                                                                    className="cartitem__name"
                                                                >
                                                                    {orderRow.name}
                                                                </a>
                                                                <span className="cartitem__art">
                                                                    ART.NR: {orderRow.articleNumber.split("-")[1]}
                                                                </span>
                                                            </div>
                                                            {!orderRow.isFreeGift &&
                                                                <a
                                                                    className="cartitem__delete"
                                                                    onClick={() => onRemoveProduct(i)}
                                                                >
                                                                    <svg className="icon">
                                                                        <use
                                                                            href="/UI/images/sprites/habo-sprite.svg#trashcan"></use>
                                                                    </svg>
                                                                </a>
                                                            }
                                                        </div>
                                                        <div className="cartitem__section cartitem__section-bottom">
                                                            {!orderRow.isFreeGift ?
                                                                <div
                                                                    className="cartitem__price cartitem__price-checkout">
                                                                    {orderRow.campaignPrice !== "" ?
                                                                        <>
                                                                          <span className="cartitem__campaign-price">
                                                                              {orderRow.totalPrice}
                                                                          </span>
                                                                            <span className="cartitem__old-price">
                                                                                {orderRow.totalRegularPrice}
                                                                            </span>
                                                                        </>
                                                                        :
                                                                        <span className="cartitem__total-price">
                                                                            {orderRow.totalPrice}
                                                                        </span>
                                                                    }
                                                                </div> :
                                                                <div className="free-gift__text mini-cart">{translate('freegift.campaign.success.text')}</div>
                                                            }

                                                            {!orderRow.isFreeGift &&
                                                                    <QuantityStepperCart
                                                                        quantity={orderRow.quantity}
                                                                        index={i}
                                                                        onQuantityChange={onQuantityChange}
                                                                        inStockQuantity={orderRow.inStockQuantity}
                                                                    />
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        )}
                                </ul>
                            </main>
                            {props.isFreeGiftCampaignActive && !props.hasFreeGift &&
                                <FreeGift
                                    isMiniCart={true}
                                    campaignText={props.freeGiftCampaignText}
                                />
                            }
                            <FreeShippingBar
                                shippingBarAmount={props.shippingBarAmount}
                                shippingBarText={props.shippingBarText}
                                percentage={props.percentageFilled}
                                place='cart'
                            />

                            <footer className="minicart-footer">
                                <div className="minicart-footer__summary">
                                    <div className="columns pt-3 pb-3 mini-cart__upsell-container">
                                        <Upsell
                                            responsiveConfig={upsellConfig}
                                            heading={translate('muha.upsell.minicart.heading')}
                                            parentClass="mini-cart__upsell"
                                            openMiniCartAtCheckout={true}
                                        />
                                    </div>

                                    <ul className="summary-list">
                                        <li>
                                            <span>{translate("minicart.ordertotalforproducts")}</span>
                                            <span>{props.orderTotal}</span>
                                        </li>
                                        <li>
                                            <span>{translate("minicart.deliverycost")}</span>
                                            <span>{props.deliveryCost}</span>
                                        </li>
                                    </ul>

                                    <ul className="summary-list">
                                        <li className="summary-list__total">
                                            <span>{translate("minicart.grandtotal")}</span>
                                            <span>{props.grandTotal}</span>
                                        </li>
                                        <li>
                                            <span>{translate("minicart.vat")}</span>
                                            <span>{props.vat}</span>
                                        </li>
                                    </ul>
                                </div>
                                {!isMuurikka &&
                                    <div className="minicart-footer__controls">
                                        <ul className="habo-btn-list">
                                            <li>
                                                <a
                                                    className="habo-btn habo-btn--big"
                                                    onClick={toggleMiniCart}
                                                >
                                                    {translate("minicart.closeminicart")}
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="habo-btn habo-btn--big habo-btn--red"
                                                    href={props.checkoutUrl}
                                                    disabled={props.orderRows.length === 0}
                                                >
                                                    {translate("minicart.checkout")}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                }

                                {isMuurikka &&
                                    <div className="minicart-footer__controls">
                                        <ul className="muurikka-btn-list">
                                            <li>
                                                <a
                                                    className="muurikka-btn muurikka-btn--big"
                                                    onClick={toggleMiniCart}
                                                >
                                                    {translate("minicart.closeminicart")}
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="muurikka-btn muurikka-btn--big muurikka-btn--red"
                                                    href={props.checkoutUrl}
                                                    disabled={props.orderRows.length === 0}
                                                >
                                                    {translate("minicart.checkout")}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                }
                            </footer>
                        </div>
                    </div>
                </div>
            }
        </>
    );
}

export default MiniCart;
